import CartItemPrice from './CartItemPrice';
import CartRemove from './CartRemove';
import QuantitySelector from '../shared-components/QuantitySelector';
import { formatMoney } from '@shopify/theme-currency';
import { getSizedImageUrl } from '@shopify/theme-images';
import { getTranslation } from '../helpers/utilities';
import { h } from 'preact';
import { useState } from 'preact/hooks';

const CartItem = ({ item }) => {
  const [error, setError] = useState();

  return (
    <div class="relative mb-6 flex">
      {item.featured_image && item.featured_image.url && (
        <div class="mr-4 md:mr-6">
          <a class="block h-20 w-16 md:h-40 md:w-32" href={item.url}>
            <img
              class="h-full w-full rounded-lg object-cover"
              alt={item.featured_image.alt}
              src={getSizedImageUrl(item.featured_image.url, 'medium')}
            />
          </a>
        </div>
      )}

      <div class="flex-1">
        <div>
          <span class="type-small mb-2 block uppercase text-stone">
            {item.vendor}
          </span>

          <div class="mb-2 flex items-start">
            <div class="flex-1">
              <a class="type-heading-8 block" href={item.url}>
                {item.product_title}
              </a>
              {!item.product_has_only_default_variant && (
                <div class="mt-2 flex flex-wrap">
                  <span class="type-small mb-1 basis-full text-stone md:mb-0 md:flex-grow-0 md:basis-0 md:after:mx-2 md:after:content-['·']">
                    {formatMoney(item.price, item.currency)}
                  </span>
                  {item.options_with_values.map(({ value }) => (
                    <span class="type-small text-stone after:mx-2 after:content-['·'] last:after:hidden">
                      {value}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div class="md:flex md:flex-row-reverse md:items-center">
              <div class="mb-2 ml-4 md:mb-0 md:ml-10">
                <CartItemPrice item={item} />
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4 flex items-center justify-between">
          <QuantitySelector item={item} setError={setError} />
          <CartRemove item={item} />
        </div>

        {/* Discounts */}
        {item.line_level_discount_allocations.length > 0 &&
          Object.entries(item.line_level_discount_allocations).map(
            ([key, value]) => (
              <div
                key={key}
                class="type-small mt-3 mb-1 inline-flex justify-center rounded-full bg-coral px-2 py-1 text-clay"
              >
                {value.discount_application.title} -{' '}
                {formatMoney(value.amount, theme.moneyFormat)}
              </div>
            ),
          )}
      </div>

      {error && (
        <div class="type-small absolute bottom-1 left-0 text-error">
          {getTranslation('cart.quantity_error', { quantity: error })}
        </div>
      )}
    </div>
  );
};

export default CartItem;
